import PageBreadcrumb from "../components/common/PageBreadCrumb";
import PageMeta from "../components/common/PageMeta";
import MarketingSeoTable from "../components/tables/MarketingSeoTable";

export default function MarketingSeoPage() {
    return (
        <>
            <PageMeta
                title="Marketing & SEO | Shoplattice Admin Dashboard"
                description="Manage SEO configurations, meta tags, and marketing content"
            />
            <PageBreadcrumb pageTitle="Marketing & SEO" />
            <div className="space-y-6">
                <MarketingSeoTable />
            </div>
        </>
    );
}
